import { useState, useEffect } from 'react';

import { some as _some, isFunction as _isFunction, get as _get } from 'lodash';

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { usePrevious } from '@vfgroup-oneplatform/foundation/Utils/Hooks';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import { PaymentScreenTypes, PaymentTypes } from '../Utils/PaymentTypes';
import { TOPUP_TAB_TYPES } from '../Utils/topUpTabTypes';

import useCustomAmount from './useCustomAmount';
import useVoucherTopup from './useVoucherTopup';

import { Dimensions, Platform } from 'react-native'

const {
  DEFAULT,
  PAYMENTREQUEST,
  ADDDATAOFFER,
  UPGRADETOOFFER,
  PAYMENTSUCCESSFULLY,
  PAYMENTFAILD,
  DATAADDED,
  OFFERGIFT,
  SETUP_AUTO_BILL_LOADING,
  SETUP_AUTO_BILL_SUCCESS,
  SETUP_AUTO_BILL_ERROR,
  SETUP_AUTO_TOP_UP_LOADING,
  SETUP_AUTO_TOP_UP_SUCCESS,
  SETUP_AUTO_TOP_UP_ERROR,
  DEFAULT_ERROR,
  TOP_UP_SOMEONE_ELSE_CONTACT_LIST,
  TOP_UP_SOMEONE_ELSE_LOADING,
  TOP_UP_SOMEONE_ELSE_ERROR,
  TOP_UP_SOMEONE_ELSE_SUCCESS,
  CUSTOM_AMOUNT,
} = PaymentScreenTypes;

const {
  SETUP_AUTO_BILL,
  EDIT_AUTO_BILL,
  SETUP_AUTO_TOP_UP,
  EDIT_AUTO_TOP_UP,
  TOP_UP_SOMEONE_ELSE,
  BALANCE_TOP_UP
} = PaymentTypes;

const handleSelectDefaultCard = (
  card,
  onSelectDefaultCard,
  paymentOptions,
  setPaymentOptions,
  status,
) => {
  onSelectDefaultCard(card);
  setPaymentOptions({
    ...paymentOptions,
    isCardListOpend: false,
    isAddDataWithGift: status === ADDDATAOFFER,
  });
};

function usePayment(props) {
  const {
    defaultWheelValue,
    onPressAddExtraOffer,
    onPressSaveCard,
    toggleModal,
    type,
    setPaymentOptions,
    onSelectDefaultCard,
    paymentOptions,
    onPressConfirmSelection,
    offerValues,
    singleValue,
    value,
    setBillStatusToSettled,
    autoBillInitialDay,
    autoTopUpInitialData,
    loadingError,
    userType,
    accounts,
    customAmountMaximum,
    getTopUpData,
    defaultPayment,
    onPressConfirmVoucherCode,
    isSelectRecipientPayGType,
  } = props;
  const [status, setStatus] = useState(null);
  const [error, setError] = useState({});

  const {
    selectedTab,
    onSelectTabChange,
    customAmountValidation,
    customAmount,
    onChangeCustomAmount,
    validateCustomAmount,
  } = useCustomAmount({
    setStatus,
    customAmountMaximum,
    defaultPayment,
    onSelectDefaultCard,
  });

  const {
    shouldScanVoucherCode,
    onQRRead,
    onCameraPressed,
    onCancelVoucherQRScanner,
    voucherTopupNumber,
    setVoucherTopupNumber,
    onCodeConfirm,
    isTwoBtnVoucherError,
    onRetryAgainPress,
    voucherAmount,
    isValidVoucherTopupNumber,
    setIsValidVoucherTopupNumber,
  } = useVoucherTopup({ type, setStatus, onPressConfirmVoucherCode, setError });

  const [selectedValue, setSelectedValue] = useState(null);
  const [newBalance, setNewBalance] = useState({});
  const [offer, setOffer] = useState(null);
  const [newExtraOffer, setNewExtraOffer] = useState({});
  const [autoBillMonth, setAutoBillMonth] = useState(undefined);
  const [autoBillDay, setAutoBillDay] = useState(autoBillInitialDay);
  const [autoTopUpData, setAutoTopUpData] = useState(autoTopUpInitialData);
  const [autoTopUpSuccessPlaceholders, setAutoTopUpSuccessPlaceholders] = useState([]);
  const prevPaymentStatus = usePrevious(status);
  const [phoneNo, setPhoneNo] = useState({});

  const [recipientName, setRecipientName] = useState(null);

  const [isValidTopupNumber, setIsValidTopupNumber] = useState(false);

  useEffect(() => {
    _isFunction(setPaymentOptions) && setPaymentOptions({});
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      if (userType === User_Types.PAY_G && type === BALANCE_TOP_UP) {
        onSelectTabChange(TOPUP_TAB_TYPES.DEFAULT_TOPUP)
        setPaymentOptions({
          ...paymentOptions,
          screen: PaymentScreenTypes.DEFAULT,
        })
      }
    }
    if (type === SETUP_AUTO_BILL || type === EDIT_AUTO_BILL) {
      setStatus(SETUP_AUTO_BILL);
    } else if (loadingError) {
      setStatus(DEFAULT_ERROR);
    } else if (type === SETUP_AUTO_TOP_UP || type === EDIT_AUTO_TOP_UP) {
      setPaymentOptions({
        ...paymentOptions,
        screen: PaymentScreenTypes.SETUP_AUTO_TOP_UP,
      });
      setStatus(DEFAULT);
    } else if (type === TOP_UP_SOMEONE_ELSE) {
      if (
        userType === User_Types.PAY_M ||
        (isSelectRecipientPayGType && userType === User_Types.PAY_G)
      ) {
        setPaymentOptions({
          ...paymentOptions,
          isTopupSomeoneElseTitleVisible: false,
          screen: PaymentScreenTypes.TOP_UP_SOMEONE_ELSE,
          withCustomTabAmount: false,
        });
        onSelectTabChange(TOPUP_TAB_TYPES.DEFAULT_TOPUP);
      } else {
        let initialAccount;
        if (_get(accounts, 'length', 0) > 0) {
          initialAccount = accounts[0];
          setPhoneNo(initialAccount?.phone);
          setRecipientName(initialAccount?.name);
        }
        setPaymentOptions({
          ...paymentOptions,
          isTopupSomeoneElseTitleVisible: true,
          topupPhoneNumber: initialAccount?.name,
        });
        setStatus(DEFAULT);
      }
    } else {
      setStatus(DEFAULT);
    }
  }, []);
  useEffect(() => {
    if (defaultWheelValue && defaultWheelValue.length && !selectedValue) {
      setSelectedValue(defaultWheelValue[0]);
    }
  }, [defaultWheelValue]);

  useEffect(() => {
    if (loadingError) {
      setStatus(DEFAULT_ERROR);
    } else if (type === SETUP_AUTO_BILL || type === EDIT_AUTO_BILL) {
      setStatus(SETUP_AUTO_BILL);
    } else {
      setStatus(DEFAULT);
    }
  }, [loadingError]);

  useEffect(() => {
    if (
      _isFunction(setBillStatusToSettled) &&
      prevPaymentStatus !== PaymentScreenTypes.PAYMENTSUCCESSFULLY &&
      status === PaymentScreenTypes.PAYMENTSUCCESSFULLY
    ) {
      setBillStatusToSettled();
    }
  }, [status]);

  const setUpError = _error => {
    setError({
      name: _error?.name,
      message: _error?.message,
      icon: _error?.icon,
    });
  };
  const onAddOffer = _offer => {
    setOffer(_offer);
  };
  const onBackFromOffer = () => {
    setStatus(DEFAULT);
  };
  const onClosePayment = async () => {
    if (status === TOP_UP_SOMEONE_ELSE_ERROR) {
      setPaymentOptions(prevOptions => ({
        ...prevOptions,
        isTopupSomeoneElseTitleVisible: true,
        title: null,
        screen: TOP_UP_SOMEONE_ELSE,
      }));
      if (selectedTab === TOPUP_TAB_TYPES.DEFAULT_TOPUP) {
        setStatus(DEFAULT);
      } else {
        setStatus(CUSTOM_AMOUNT);
      }
    } else {
      await toggleModal();
      setStatus(DEFAULT);
      setSelectedValue(defaultWheelValue && defaultWheelValue[0]);
      setPaymentOptions(preOptions => ({
        ...preOptions,
        isPaymentDismissed: true,
      }));
    }
  };

  const onSelectWheelValue = wheelValueSelected => {
    setSelectedValue(wheelValueSelected);
  };
  const onSelectBillDay = selectedDay => {
    setAutoBillDay(selectedDay);
  };

  const onSelectAutoTopUpData = data => {
    setAutoTopUpData(data);
  };

  const setAutoBillTitle = () => {
    if (type === SETUP_AUTO_BILL) {
      setPaymentOptions({
        ...paymentOptions,
        title: 'auto_bill_quick_action_title',
      });
    }
  };

  const onConfirmPayment = paymentCardData => {
    setPaymentOptions(preOptions => ({
      ...preOptions,
      isCardListOpend: false,
      withCustomTabAmount: false,
    }));
    if (defaultWheelValue && _some(defaultWheelValue, 'gift')) {
      if (selectedValue && !selectedValue.gift) {
        setStatus(UPGRADETOOFFER);
      } else {
        setStatus(OFFERGIFT);
      }
    } else if (status === TOP_UP_SOMEONE_ELSE_ERROR) {
      // setStatus(TOP_UP_SOMEONE_ELSE_LOADING);
      setPaymentOptions(prevOptions => ({
        ...prevOptions,
        screen: TOP_UP_SOMEONE_ELSE_LOADING
      }))
      onPressConfirmSelection({
        selectedValue:
          selectedTab === TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP
            ? { value: customAmount }
            : selectedValue,
        paymentCardData,
        topupPhoneNumber: paymentOptions.topupPhoneNumber,
      })
        .then(data => {
          setNewBalance(data);
          setStatus(TOP_UP_SOMEONE_ELSE_SUCCESS);
          setPaymentOptions(prevOptions => ({
            ...prevOptions,
            screen: TOP_UP_SOMEONE_ELSE_SUCCESS
          }))
        })
        .catch(_error => {
          setUpError(_error);
          setStatus(TOP_UP_SOMEONE_ELSE_ERROR);
          setPaymentOptions(prevOptions => ({
            ...prevOptions,
            screen: TOP_UP_SOMEONE_ELSE_ERROR
          }))
        });
    } else if (type === TOP_UP_SOMEONE_ELSE) {
      setPaymentOptions(prevOptions => ({
        ...prevOptions,
        isTopupSomeoneElseTitleVisible: true,
        title: ContentManager.translate('top_up_someone_else_quick_action_title_with_formatting', [
          recipientName || `   ${phoneNo}`,
        ]),
        screen: TOP_UP_SOMEONE_ELSE_LOADING
      }));
      setStatus(TOP_UP_SOMEONE_ELSE_LOADING);
      onPressConfirmSelection({
        selectedValue:
          selectedTab === TOPUP_TAB_TYPES.CUSTOM_AMOUNT_TOPUP
            ? { value: customAmount }
            : selectedValue,
        paymentCardData,
        topupPhoneNumber: paymentOptions.topupPhoneNumber,
      })
        .then(data => {
          setNewBalance(data);
          setStatus(TOP_UP_SOMEONE_ELSE_SUCCESS);
          setPaymentOptions(prevOptions => ({
            ...prevOptions,
            isTopupSomeoneElseTitleVisible: true,
            title: ContentManager.translate(
              'top_up_someone_else_quick_action_title_with_formatting',
              [recipientName || `   ${phoneNo}`]
            ),
            screen: TOP_UP_SOMEONE_ELSE_SUCCESS
          }))
        })
        .catch(_error => {
          setUpError(_error);
          setStatus(TOP_UP_SOMEONE_ELSE_ERROR);
          setPaymentOptions(prevOptions => ({
            ...prevOptions,
            isTopupSomeoneElseTitleVisible: true,
            title: ContentManager.translate(
              'top_up_someone_else_quick_action_title_with_formatting',
              [recipientName || `   ${phoneNo}`]
            ),
            screen: TOP_UP_SOMEONE_ELSE_ERROR
          }))
        });
    } else if (status === SETUP_AUTO_BILL_ERROR) {
      setStatus(SETUP_AUTO_BILL);
    } else if (type === SETUP_AUTO_BILL || type === EDIT_AUTO_BILL) {
      setStatus(SETUP_AUTO_BILL_LOADING);
      onPressConfirmSelection({
        selectedDay: autoBillDay,
      })
        .then(data => {
          const { day, month } = data;
          setAutoBillDay(day);
          setAutoBillMonth(month);
          setAutoBillTitle();
          setStatus(SETUP_AUTO_BILL_SUCCESS);
        })
        .catch(_error => {
          setUpError(_error);
          setStatus(SETUP_AUTO_BILL_ERROR);
        });
    } else if (
      type === SETUP_AUTO_TOP_UP ||
      type === EDIT_AUTO_TOP_UP ||
      status === SETUP_AUTO_TOP_UP_ERROR
    ) {
      setStatus(SETUP_AUTO_TOP_UP_LOADING);
      onPressConfirmSelection({
        autoTopUpData: { ...autoTopUpData, autoTopUpValue: selectedValue },
      })
        .then(data => {
          setAutoTopUpSuccessPlaceholders(data);
          setStatus(SETUP_AUTO_TOP_UP_SUCCESS);
        })
        .catch(_error => {
          setUpError(_error);
          setStatus(SETUP_AUTO_TOP_UP_ERROR);
        });
    } else {
      setPaymentOptions(preOptions => ({
        ...preOptions,
        isConfirmPayment: true,
      }));
      setStatus(PAYMENTREQUEST);
      onPressConfirmSelection({
        selectedValue: singleValue ? value : selectedValue,
        paymentCardData,
      })
        .then(data => {
          setNewBalance(data);
          setError({});
          setPaymentOptions(preOptions => ({
            ...preOptions,
            isConfirmPayment: false,
          }));
          setStatus(PAYMENTSUCCESSFULLY);
        })
        .catch(_error => {
          setUpError(_error);
          setPaymentOptions(preOptions => ({
            ...preOptions,
            isConfirmPayment: false,
          }));
          setStatus(PAYMENTFAILD);
        });
    }
  };

  const onCompletePurchaseOfferPress = () => {
    setStatus(PAYMENTREQUEST);
    const topupValue = { ...(singleValue ? value : selectedValue) };
    topupValue.value = parseFloat(topupValue.value) + parseFloat(offer ? offer.giftOfferPrice : 0);
    onPressConfirmSelection({
      selectedValue: topupValue,
    })
      .then(data => {
        setNewBalance(data);

        setStatus(PAYMENTSUCCESSFULLY);
        setOffer(null);
      })
      .catch(_error => {
        setUpError(_error);
        setStatus(PAYMENTFAILD);
      });
  };

  const onBuyOffer = paymentCardData => {
    setStatus(PAYMENTREQUEST);

    onPressAddExtraOffer({ offerValue: offerValues, paymentCardData })
      .then(data => {
        setNewExtraOffer(data);
        setStatus(DATAADDED);
      })
      .catch(_error => {
        setUpError(_error);
        setStatus(PAYMENTFAILD);
      });
  };

  const onUpgradePayment = () => {
    setStatus(PAYMENTREQUEST);
    onPressConfirmSelection({
      selectedValue: defaultWheelValue && defaultWheelValue[0],
    })
      .then(data => {
        setSelectedValue(defaultWheelValue && defaultWheelValue[0]);
        setNewBalance(data);
        setStatus(OFFERGIFT);
      })
      .catch(_error => {
        setUpError(_error);
        setStatus(PAYMENTFAILD);
      });
  };

  const onRejectUpgradePayment = () => {
    setStatus(PAYMENTREQUEST);
    onPressConfirmSelection({
      selectedValue: singleValue ? value : selectedValue,
    })
      .then(data => {
        setNewBalance(data);
        setStatus(PAYMENTSUCCESSFULLY);
      })
      .catch(_error => {
        setUpError(_error);
        setStatus(PAYMENTFAILD);
      });
  };

  const onDiscardGift = async () => {
    setPaymentOptions({ ...paymentOptions, isCardListOpend: false });
    onClosePayment();
  };
  const onAddCard = () => {
    setPaymentOptions({
      ...paymentOptions,
      screen: PaymentScreenTypes.ADD_PAYMENT_CARD,
      title: 'quick_action_add_new_payment_card_title',
      isBackButton: true,
      isTopupSomeoneElseTitleVisible: false,
    });
  };

  const goBackView = () => {
    if (userType === 'payG' && Dimensions.get('window').width > 700 && Platform.OS === 'web' || type === PaymentTypes.BILLING_PAYMENT) {
      setPaymentOptions({
        ...paymentOptions,
        screen: PaymentScreenTypes.DEFAULT,
        title: 'quick_action_add_new_payment_card_title',
        isBackButton: true,
        isTopupSomeoneElseTitleVisible: false
      })
    } else {
      setPaymentOptions({
        ...paymentOptions,
        screen: PaymentScreenTypes.TOP_UP_SOMEONE_ELSE,
        title: 'quick_action_add_new_payment_card_title',
        isBackButton: true,
        isTopupSomeoneElseTitleVisible: false
      })
    }
  }

  const goBack = () => {
    setStatus('CUSTOM_AMOUNT')
  }

  const onOpenCardList = () => {
    setPaymentOptions({
      ...paymentOptions,
      isCardListOpend: !paymentOptions.isCardListOpend,
    });
  };

  const onSaveNewCard = cardData => {
    setPaymentOptions({
      ...paymentOptions,
      title: null,
      isBackButton: false,
      screen: null,
      isCardListOpend: false,
      isSaveNewCard: true,
    });
    if (type === SETUP_AUTO_BILL || type === EDIT_AUTO_BILL) {
      setStatus(SETUP_AUTO_BILL_LOADING);
      onPressSaveCard(cardData)
        .then(res => {
          setStatus(SETUP_AUTO_BILL);
        })
        .catch(err => {
          setStatus(SETUP_AUTO_BILL);
        });
    } else {
      setStatus(PAYMENTREQUEST);
      onPressSaveCard(cardData)
        .then(res => {
          setStatus(DEFAULT);
        })
        .catch(err => {
          setStatus(DEFAULT);
        })
        .finally(() => {
          setPaymentOptions(preOptions => ({
            ...preOptions,
            isTopupSomeoneElseTitleVisible: type === PaymentTypes.TOP_UP_SOMEONE_ELSE,
            isSaveNewCard: false,
          }));
        });
    }
  };

  const onSaveTopUpSomeOneCard = (phone, name) => {
    setPhoneNo(phone);
    setRecipientName(name);
    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: null,
      topupPhoneNumber: name || phone,
      isBackButton: false,
      isTopupSomeoneElseTitleVisible: true,
      withCustomTabAmount: true,
    }));
    getTopUpData();
    onSelectTabChange(selectedTab);
  };

  const onTopUpRecipientNumberSubmit = () => {
    setRecipientName(null);
    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: null,
      isTopupSomeoneElseTitleVisible: true,
      topupPhoneNumber: phoneNo,
      withCustomTabAmount: true,
    }));
    getTopUpData();
    onSelectTabChange(selectedTab);
  };

  const checkObjectHasProperty = (obj, property) => {
    if (!obj) {
      return '';
    } else {
      if (obj.hasOwnProperty(property)) {
        return obj[property];
      } else {
        return '';
      }
    }
  };

  const onContactListIconPress = () => {
    setPaymentOptions({
      ...paymentOptions,
      screen: TOP_UP_SOMEONE_ELSE_CONTACT_LIST,
      isBackButton: true,
    });
  };

  const onAutoTopUpNext = () => {
    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: null,
      autoTopUpData,
    }));
    setStatus(DEFAULT);
  };

  const onAutoTopUpErrorReturn = () => {
    setPaymentOptions(prevOptions => ({
      ...prevOptions,
      screen: null,
      autoTopUpData,
    }));
    setStatus(DEFAULT);
  };

  return {
    status,
    selectedValue,
    handleSelectDefaultCard: card =>
      handleSelectDefaultCard(card, onSelectDefaultCard, paymentOptions, setPaymentOptions, status),
    onSaveNewCard,
    onOpenCardList,
    onAddCard,
    checkObjectHasProperty,
    onDiscardGift,

    onBuyOffer,
    onSelectWheelValue,
    onUpgradePayment,
    onRejectUpgradePayment,
    onClosePayment,
    onCompletePurchaseOfferPress,
    onConfirmPayment,
    newBalance,
    newExtraOffer,
    autoBillMonth,
    autoBillDay,
    autoTopUpData,
    autoTopUpSuccessPlaceholders,
    onSelectBillDay,
    onSelectAutoTopUpData,
    error,
    phoneNo,
    onAddOffer,
    onBackFromOffer,
    setPhoneNo,
    onSaveTopUpSomeOneCard,
    onTopUpRecipientNumberSubmit,
    onAutoTopUpNext,
    onAutoTopUpErrorReturn,
    setIsValidTopupNumber,
    isValidTopupNumber,
    onContactListIconPress,
    selectedTab,
    onSelectTabChange,
    customAmountValidation,
    customAmount,
    onChangeCustomAmount,
    validateCustomAmount,
    setAutoBillTitle,
    isValidVoucherTopupNumber,
    setIsValidVoucherTopupNumber,
    shouldScanVoucherCode,
    onCameraPressed,
    onQRRead,
    onCancelVoucherQRScanner,
    voucherTopupNumber,
    setVoucherTopupNumber,
    onCodeConfirm,
    isTwoBtnVoucherError,
    onRetryAgainPress,
    voucherAmount,
    goBackView
  };
}
export { handleSelectDefaultCard };
export default usePayment;
